// src/ui/tokens.ts
// Central design tokens — import these instead of hardcoding raw values in pages.
// Works with the existing s() / px() / sfpx() inline-style scaling system.

export const COLOR = {
    text:        "#111",      // primary text
    textMuted:   "#71717a",   // secondary / helper labels
    textLight:   "#a1a1aa",   // tertiary / placeholder
    textDark:    "#18181b",   // extra-dark headings
    black:       "#000",      // hard black (borders, filled buttons)
    white:       "#fff",
    bgLight:     "#f4f4f5",   // input / card backgrounds
    bgLighter:   "#f8fafc",   // thumbnail / panel backgrounds
    border:      "#e5e7eb",   // standard light border
    borderAlt:   "#e4e4e7",   // alternate light border
    borderMuted: "#eee",      // dividers / subtle lines
    error:       "#d00",      // error / danger
    warning:     "#d97706",   // amber warning
    success:     "#0a7",      // success green
} as const;

export const FW = {
    regular:   400,
    medium:    600,
    bold:      700,
    extraBold: 800,
    black:     900,
} as const;

// Design-unit values — always pass through s() for scaling: s(RADIUS.md)
export const RADIUS = {
    xs:   6,
    sm:   8,
    md:   12,
    lg:   16,
    xl:   20,
    xxl:  30,
    full: 999,
} as const;

// Pre-composed border strings (no scaling needed — border-width is always 1px)
export const BORDER = {
    light:    `1px solid ${COLOR.border}`,
    lightAlt: `1px solid ${COLOR.borderAlt}`,
    muted:    `1px solid ${COLOR.borderMuted}`,
    dark:     `1px solid ${COLOR.black}`,
    boldDark: `1.5px solid ${COLOR.black}`,
    darkText: `1px solid ${COLOR.text}`,
} as const;
